module.exports = __webpack_public_path__ + "img/battery_blue.54435361.svg";